export default {
  namespace: "work",
};
